import React, { useState } from "react"
import styled from "styled-components"
import colors from "styles/colors"
import media from "styles/media"
import MarketoForm from "./MarketoForm"

const LightboxBtn = props => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
  }

  return (
    <LightboxContainer>
      <PrimaryCta onClick={handleOpen}>{props.lightboxText}</PrimaryCta>
      {isOpen && (
        <Overlay>
          <FormContent>
            <CloseBtn onClick={handleClose}>ⓧ</CloseBtn>
            <MarketoForm id={props.formId} ty={props?.ty} mode={props?.mode} />
          </FormContent>
        </Overlay>
      )}
    </LightboxContainer>
  )
}

const PrimaryCta = styled.button`
  background-color: ${colors.primaryOrange};
  color: white;
  text-transform: uppercase;
  padding: 0.556vw 2.083vw;
  border-radius: 1.667vw;
  font-family: "Archivo", sans-serif;

  ${media.fullWidth} {
    padding: 8px 30px;
    border-radius: 24px;
  }
  ${media.tablet} {
    padding: 0.781vw 2.93vw;
    border-radius: 2.344vw;
  }
  ${media.mobile} {
    padding: 1.869vw 7.009vw;
    border-radius: 5.607vw;
    margin-bottom: 4.673vw;
  }
  &:hover {
    background-color: ${colors.white};
    color: ${colors.primaryOrange};
    outline: solid ${colors.primaryOrange} 1px;
  }
`
const LightboxContainer = styled.div``

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

const FormContent = styled.div`
  position: relative;
  background-color: transparent;
  padding: 1.389vw;
  border-radius: 1.389vw;

  ${media.fullWidth} {
    padding: 20px;
    border-radius: 20px;
  }
  ${media.tablet} {
    padding: 1.953vw;
    border-radius: 1.953vw;
  }
  ${media.mobile} {
    padding: 4.673vw;
    border-radius: 4.673vw;
  }
`
const CloseBtn = styled.p`
  position: absolute;
  z-index: 10000;
  font-size: 1.389vw;
  top: 2vw;
  right: 2vw;
  font-family: "Archivo";
  color: ${colors.black};
  cursor: pointer;

  ${media.fullWidth} {
    font-size: 20px;
    top: 29px;
    right: 29px;
  }
  ${media.tablet} {
    top: 3vw;
    right: 3vw;
    font-size: 1.953vw;
  }
  ${media.mobile} {
    top: 7vw;
    right: 7vw;
    font-size: 4.673vw;
  }
`

export default LightboxBtn
